import { FC } from "react";

export const DeleteSponsorTagIcon: FC = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3.02734L3 9.02734"
        stroke="#292E73"
        strokeOpacity="0.82"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 3.02734L9 9.02734"
        stroke="#292E73"
        strokeOpacity="0.82"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
